import { DescriptionBlock } from "../DescriptionBlock";
import { Container } from "./styles";

export function SectionCoworking() {
  return (
    <Container>
      <div>
        <DescriptionBlock text="Um ambiente tranquilo e funcional para você ter mais qualidade de vida no trabalho." />
      </div>
    </Container>
  );
}
